module.exports = __webpack_public_path__ + "img/2.48744ab1.jpg";